import AboutUs from '../sections/about-us/AboutUs';
import App from '../App';

window.App = App;
window.Section = AboutUs;


